module.exports = __webpack_public_path__ + "img/success-icon.9dbb39b4.svg";